const UNITS = ['B', 'KB', 'MB', 'GB'] as const;
const KILO = 1024;

type FormatOptions = {
  precision?: number;
  unit?: (typeof UNITS)[number];
};

export function formatBytes(bytes: number, options: FormatOptions = {}) {
  const { precision = 2, unit } = options;
  let result = bytes;
  let unitIndex = 0;
  const condition = () => (unit ? UNITS.indexOf(unit) !== unitIndex : result >= KILO);

  while (condition()) {
    result /= KILO;
    unitIndex++;
  }

  return `${Number(result.toFixed(precision))} ${UNITS[unitIndex]}`;
}
